<div [formGroup]="appVersionsForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="minAppVersion"
    placeholder="coreModule.appVersionsDialogComponent.form.minAppVersion.placeholder"
    label="coreModule.appVersionsDialogComponent.form.minAppVersion.label">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="latestAppVersion"
    placeholder="coreModule.appVersionsDialogComponent.form.latestAppVersion.placeholder"
    label="coreModule.appVersionsDialogComponent.form.latestAppVersion.label">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="minAppVersion_IOS"
    placeholder="coreModule.appVersionsDialogComponent.form.minAppVersion_IOS.placeholder"
    label="coreModule.appVersionsDialogComponent.form.minAppVersion_IOS.label">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="latestAppVersion_IOS"
    placeholder="coreModule.appVersionsDialogComponent.form.latestAppVersion_IOS.placeholder"
    label="coreModule.appVersionsDialogComponent.form.latestAppVersion_IOS.label">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="minAppVersion_ANDROID"
    placeholder="coreModule.appVersionsDialogComponent.form.minAppVersion_ANDROID.placeholder"
    label="coreModule.appVersionsDialogComponent.form.minAppVersion_ANDROID.label">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="latestAppVersion_ANDROID"
    placeholder="coreModule.appVersionsDialogComponent.form.latestAppVersion_ANDROID.placeholder"
    label="coreModule.appVersionsDialogComponent.form.latestAppVersion_ANDROID.label">
  </nx-edit-text-input>
<div>